import { InfoCircle } from "react-bootstrap-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface TooltipInfoProps {
  message: string;
  placement?: "top" | "right" | "bottom" | "left";
  style?: React.CSSProperties;
}

export const TooltipInfo = ({
  message,
  placement = "top",
  style,
}: TooltipInfoProps) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip id={`tooltip-${placement}`}>{message}</Tooltip>}
    >
      <span data-testid="tooltip-icon" style={{ cursor: "pointer", ...style }}>
        <InfoCircle size={16} />
      </span>
    </OverlayTrigger>
  );
};
